if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.drawerCart = document.querySelector('drawer-cart');
      this.drawerCartItems = document.querySelector('cart-items');
      this.footerCart = document.getElementById('main-cart-footer');
      this.buttonCheckout = document.getElementById('checkout');
    }

    onSubmitHandler(evt) {

      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      var settings = {
        speedOpen: 50,
        activeClass: 'is-active',
        visibleClass: 'is-visible',
      };
  
      var toggleccessibility = function (event) {
        if (event.getAttribute('aria-expanded') === 'true') {
          event.setAttribute('aria-expanded', false);
        } else {
          event.setAttribute('aria-expanded', true);
        }
      };

      var openDrawer = function (trigger) {
        var target = document.getElementById(trigger.getAttribute('aria-controls'));        
        target.classList.add(settings.activeClass);
        // document.documentElement.style.overflow = 'hidden';
        toggleccessibility(trigger);
  
        setTimeout(function () {
          target.classList.add(settings.visibleClass);
        }, settings.speedOpen);
      };

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const addToCartEvent = new CustomEvent("addedToCart", { detail: response });
          document.dispatchEvent(addToCartEvent);
          
          this.CartItems;
          openDrawer(submitButton);
          this.drawerCartItems.classList.remove('is-empty');
          this.footerCart.classList.remove('is-empty');
          this.buttonCheckout.disabled = false;

          let variantID = document.querySelector('li[data-id="' + response.variant_id + '"]');

          if (variantID != null) {
            let variantLine = variantID.getAttribute('data-index');
            var line = variantLine;
          } else {
            var line = 1;
          }
          
          let quantity = response.quantity;
          const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          });
          fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => response.json())
          .then((state) => {
            const parsedState = state;
            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

            }));
          
          }).catch((e) => {
            console.error(e);
          })
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents-items',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents-footer',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents-co2',
        }
      ];
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}